import React from 'react';
import classNames from 'classnames';
const Search = ({ isFocused, isOpenable, children }) => (<div className={classNames('search', 'dropdown', {
        'search--open': isOpenable && isFocused,
    }, {
        'search--static': !isOpenable,
    })}>
        {children}
    </div>);
Search.defaultProps = {
    isOpenable: true,
};
export default Search;
